export default __webpack_public_path__ + "static/media/manabp.8039cf87.svg";